import { userConstants as constants } from '../_constants/user.constants';

export const initialState = {
  currentUser: null,
  isLoading: false,
  collection: [],
  page: 1
}

export function user(state = initialState, action) {
  if (action.type === constants.SET_CURRENT_USER) {
    return {
      ...state,
      currentUser: action.user,
      isLoadingUser: false
    }
  }
  if (action.type === constants.USERS_SET_PAGE) {
    return {
      ...state,
      page: action.page
    }
  }

  if (action.type === constants.USERS_RETRIEVE_REQUEST) {
    return {
      ...state,
      isLoading: true
    }
  }

  if (action.type === constants.USERS_RETRIEVE_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      collection: action.users
    }
  }

  if (action.type === constants.USERS_RETRIEVE_FAILURE) {
    return {
      ...state,
      isLoading: false
    }
  }

  return state;
}
